import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../store/AuthContext';

function ProtectedRoute({ children, requiresAdmin = false }) {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // 记录原始目标地址，登录成功后回跳（如邮件内点击的会话详情链接）
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiresAdmin && user?.role !== 'admin') {
    return <Navigate to="/files" replace />;
  }

  return children;
}

export default ProtectedRoute;
